var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.6667 6.79301H11.7401C10.1601 6.79301 8.87341 5.50634 8.87341 3.92634V1.99967C8.87341 1.63301 8.57341 1.33301 8.20675 1.33301H5.38008C3.32675 1.33301 1.66675 2.66634 1.66675 5.04634V10.953C1.66675 13.333 3.32675 14.6663 5.38008 14.6663H10.6201C12.6734 14.6663 14.3334 13.333 14.3334 10.953V7.45967C14.3334 7.09301 14.0334 6.79301 13.6667 6.79301Z",
    fill: "#8DC63F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5333 1.47365C10.26 1.20032 9.78662 1.38699 9.78662 1.76699V4.09365C9.78662 5.06699 10.6133 5.87365 11.62 5.87365C12.2533 5.88032 13.1333 5.88032 13.8866 5.88032C14.2666 5.88032 14.4666 5.43365 14.2 5.16699C13.24 4.20032 11.52 2.46032 10.5333 1.47365Z",
    fill: "#8DC63F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentEdit);
export default __webpack_public_path__ + "static/media/DocumentEdit.2358ef3cd17f1f25e0d8eb915a9e0eae.svg";
export { ForwardRef as ReactComponent };